import type { FC, ReactNode } from 'react'

import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react'

interface IntroState {
    windowReady: boolean
    introStarted: boolean
    markWindowReady: () => void
    startIntro: () => void
}

interface IntroProviderProps {
    children: ReactNode
}

const IntroContext = createContext<IntroState>({
    windowReady: false,
    introStarted: false,
    markWindowReady: () => {},
    startIntro: () => {}
})

export const useIntro = (): IntroState => useContext(IntroContext)

export const IntroProvider: FC<IntroProviderProps> = ({ children }): ReactNode => {
    const [windowReady, setWindowReady] = useState(false)
    const [introStarted, setIntroStarted] = useState(false)

    const markWindowReady = useCallback((): void => setWindowReady(true), [])
    const startIntro = useCallback((): void => setIntroStarted(true), [])

    const value = useMemo<IntroState>(() => ({
        windowReady,
        introStarted,
        markWindowReady,
        startIntro
    }), [windowReady, introStarted, markWindowReady, startIntro])

    return (
        <IntroContext.Provider value={value}>
            {children}
        </IntroContext.Provider>
    )
}
